export const FALLBACK_LANG = 'EN';
export const getFilteredProductManualKeys = (productManual) => {
    if (!productManual) {
        return [];
    }
    return Object.keys(productManual.productManualByLanguage).filter((key) => productManual.productManualByLanguage[key] &&
        productManual.productManualByLanguage[key].document &&
        productManual.productManualByLanguage[key].showOnWebsite);
};
export const getProductManualDocument = (filteredProductManualKeys, lang, productManual, fallBackLang) => {
    if (filteredProductManualKeys.includes(lang.toUpperCase())) {
        return productManual.productManualByLanguage[lang.toUpperCase()].document;
    }
    if (filteredProductManualKeys.includes(fallBackLang)) {
        return productManual.productManualByLanguage[fallBackLang].document;
    }
    return productManual.productManualByLanguage[filteredProductManualKeys[0]].document;
};
